/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Filter_Status_LabelInputs */



/**
* | output |
* | --- |
* | "Filter by status" |
*
* @param {Manual_Qc_Filter_Status_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_filter_status_label = /** @type {((inputs?: Manual_Qc_Filter_Status_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Filter_Status_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filtrer par statut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nach Status filtern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filtra per stato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фильтрация по статусу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filtrar por estado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按状态筛选")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ステータスでフィルタリング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति के अनुसार फ़िल्टर करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Filtrar por status")
	return /** @type {LocalizedString} */ ("Filter by status")
});